import { defineComponent as n, createBlock as r, openBlock as a, unref as i, mergeProps as l, withCtx as p, createElementVNode as c } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const u = /* @__PURE__ */ n({
  name: "IconWifi",
  __name: "IconWifi",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (f, e) => (a(), r(i(m), l(t, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        c("path", {
          "fill-rule": "evenodd",
          d: "M2.984 8.86a.75.75 0 0 0 1.061 1.06c4.393-4.393 11.517-4.393 15.91 0a.75.75 0 0 0 1.06-1.06c-4.979-4.98-13.051-4.98-18.03 0m2.829 2.828a.75.75 0 0 0 1.06 1.06 7.25 7.25 0 0 1 10.253 0 .75.75 0 0 0 1.061-1.06 8.75 8.75 0 0 0-12.374 0m2.828 3.889a.75.75 0 0 1 0-1.06 4.75 4.75 0 0 1 6.718 0 .75.75 0 1 1-1.061 1.06 3.25 3.25 0 0 0-4.596 0 .75.75 0 0 1-1.06 0M12 18.875a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
